import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const unlinkEvaluationFromModule = (
  moduleId: string,
  evaluationId: number,
  language: string,
  onSuccess: Function,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.delete(`modules/${moduleId}/evaluations/${evaluationId}`)
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error unlinking evaluation from module", error);
      alert(translate(language, "PAGES.MODULE.EVALUATIONS.UNLINK_EVALUATION_POPUP.ERROR"));
    })
    .finally(() => setLoading(false));
};
